import theme from '../../theme/theme';

const {
  colors: { black_text },
} = theme;

const styles = {
  container: {
    display: 'flex',
    flex: 1,
    height: '4.625em',
    paddingLeft: '1.9em',
  },

  title__container: {
    display: 'flex',
    flex: 1,
  },

  title: {
    color: black_text,
    fontSize: '1.250em',
    fontWeight: 'normal',
    letterSpacing: '-0.031em',
    paddingLeft: '0.6em',
    paddingTop: '.2em',
  },
};

export default styles;
